import t from "./ghl-ui.es675.js";
import o from "./ghl-ui.es676.js";
import f from "./ghl-ui.es677.js";
import i from "./ghl-ui.es386.js";
import e from "./ghl-ui.es678.js";
function c(r) {
  return typeof r == "function" ? r : r == null ? f : typeof r == "object" ? i(r) ? o(r[0], r[1]) : t(r) : e(r);
}
export {
  c as default
};
